import { Layout, LayoutProps, Loading } from 'react-admin';
import { useTermsAgreement } from './common_modules/hooks/TermsAgreementContext';

export const CustomLayout = (props: LayoutProps) => {
  const { isLoading } = useTermsAgreement();

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Layout
      {...props}
      sx={{
        '& .RaSidebar-drawerPaper': {
          height: '100dvh'
        }
      }}
    />
  );
};
